import { useState } from "react";
import { ChevronDown } from "lucide-react";

function FaqItem({ q, a, defaultOpen = false, idx }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-slate-200" data-testid={`faq-item-${idx}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-start justify-between text-left py-5 gap-6"
        data-testid={`faq-toggle-${idx}`}
      >
        <h4 className="font-display text-lg tracking-tight text-slate-950">{q}</h4>
        <ChevronDown className={`w-5 h-5 shrink-0 mt-1 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <p className="text-slate-700 leading-relaxed pb-6 pr-10" data-testid={`faq-answer-${idx}`}>{a}</p>
      )}
    </div>
  );
}

export default function StoreContent({ content, storeName }) {
  if (!content) return null;
  return (
    <section className="mt-20 border-t border-slate-200 pt-16" data-testid="store-content-section">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 space-y-12">
          {/* Intro */}
          <div>
            <p className="overline mb-3">About</p>
            <h2 className="font-display text-3xl md:text-4xl tracking-tight mb-5">
              About {storeName} coupons
            </h2>
            <p className="text-slate-700 leading-relaxed text-lg">{content.intro}</p>
          </div>

          {/* How to use */}
          <div>
            <p className="overline mb-3">The process</p>
            <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-6">
              How to use {storeName} promo codes
            </h3>
            <ol className="space-y-4" data-testid="how-to-list">
              {content.how_to_steps?.map((step, i) => (
                <li key={i} className="flex gap-5 items-start border-l-2 border-emerald-500 pl-5">
                  <span className="font-display text-3xl tracking-tighter text-emerald-600 leading-none shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="text-slate-700 leading-relaxed pt-1">{step}</p>
                </li>
              ))}
            </ol>
          </div>

          {/* FAQ */}
          <div>
            <p className="overline mb-3">Common questions</p>
            <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-6">
              {storeName} coupon FAQ
            </h3>
            <div data-testid="faq-list">
              {content.faqs?.map((f, i) => (
                <FaqItem key={i} q={f.q} a={f.a} defaultOpen={i === 0} idx={i} />
              ))}
            </div>
          </div>
        </div>

        {/* Tips sidebar */}
        <aside className="lg:col-span-1">
          <div className="border border-slate-200 rounded-sm p-6 bg-slate-950 text-slate-100 sticky top-24">
            <p className="overline mb-4 text-emerald-400">Pro tips</p>
            <h3 className="font-display text-xl tracking-tight mb-6">
              Save even more at {storeName}
            </h3>
            <ul className="space-y-4" data-testid="tips-list">
              {content.savings_tips?.map((tip, i) => (
                <li key={i} className="flex gap-3 text-sm text-slate-300 leading-relaxed">
                  <span className="text-emerald-400 font-bold shrink-0">›</span>
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}
